__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "bbas";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@cxc/react-connected-components", "0.118.6", () => (__webpack_require__.e(9169).then(() => (() => (__webpack_require__(9169))))));
			register("@cxc/react-universal-components", "0.75.43", () => (() => (__webpack_require__(643))), 1);
			register("@reduxjs/toolkit", "2.5.0", () => (() => (__webpack_require__(8740))), 1);
			register("@ucl/react-library", "5.2.0", () => (() => (__webpack_require__(4498))), 1);
			register("@ucl/shared-component-foundations", "5.2.0", () => (() => (__webpack_require__(6034))), 1);
			register("dompurify", "3.2.6", () => (__webpack_require__.e(4997).then(() => (() => (__webpack_require__(4997))))));
			register("fuse.js", "7.1.0", () => (__webpack_require__.e(2384).then(() => (() => (__webpack_require__(2384))))));
			register("html-react-parser", "5.2.2", () => (__webpack_require__.e(9030).then(() => (() => (__webpack_require__(6649))))));
			register("i18next-browser-languagedetector", "7.2.2", () => (__webpack_require__.e(8527).then(() => (() => (__webpack_require__(8527))))));
			register("i18next-resources-to-backend", "1.2.1", () => (__webpack_require__.e(6332).then(() => (() => (__webpack_require__(6332))))));
			register("i18next", "23.16.8", () => (__webpack_require__.e(2526).then(() => (() => (__webpack_require__(2526))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-helmet", "6.1.0", () => (__webpack_require__.e(8154).then(() => (() => (__webpack_require__(8154))))));
			register("react-hook-form", "7.54.2", () => (__webpack_require__.e(7286).then(() => (() => (__webpack_require__(7286))))));
			register("react-i18next", "14.1.3", () => (__webpack_require__.e(4746).then(() => (() => (__webpack_require__(2365))))));
			register("react-redux", "8.1.3", () => (() => (__webpack_require__(9675))), 1);
			register("react-router-dom", "6.28.2", () => (() => (__webpack_require__(4976))), 1);
			register("react-router", "6.28.2", () => (() => (__webpack_require__(7767))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			register("styled-components", "6.1.13", () => (() => (__webpack_require__(8634))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};